import { createTheme } from '@mui/material';

export const WebsiteTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#98cc3c',
        },
        secondary: {
            main: '#f50057',
        },
        lightgray: {
            main: '#f0f0f0',
        }
    },
});
